document.addEventListener('DOMContentLoaded', () => {
	// 1. The Debounce Function
	// This ensures we don't recalculate 100 times per second while dragging the window
	function debounce(func, wait) {
		let timeout;
		return function executedFunction(...args) {
			const later = () => {
			clearTimeout(timeout);
			func(...args);
			};
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	}
	
	// The Position Logic
	function adjustCtaPosition() {
		const cta = document.querySelector('.sticky-cta');
		
		if (!cta) return;
		
		// Configuration
		const defaultTop = 500; // Standard position
		const minBottomGap = 40; // Minimum distance from bottom
		
		// Get current dimensions
		const viewportHeight = window.innerHeight;
		const elementHeight = cta.offsetHeight;
		
		// Calculate the lowest 'top' value allowed before we violate the 40px gap
		// Formula: Viewport - Element Height - Safety Gap
		const maxAllowedTop = viewportHeight - elementHeight - minBottomGap;
		
		// Logic: Use the smaller of the two numbers.
		// If defaultTop (500) is larger than what fits (maxAllowedTop), use maxAllowedTop.
		if (defaultTop > maxAllowedTop) {
			cta.style.top = `${maxAllowedTop}px`;
		} else {
			cta.style.top = `${defaultTop}px`;
		}
	}
	
	adjustCtaPosition();
	
	window.addEventListener('resize', debounce(adjustCtaPosition, 100));
});